import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '../../assets/images/404.png';
const _hoisted_1 = {
  class: "content-center"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-bottom": "20px"
  }
}, " 您访问的页面不存在或页面出错 ~ ", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_base_menu = _resolveComponent("base-menu");
  return _openBlock(), _createBlock(_component_base_menu, {
    type: "not-found"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.toLastPage
    }, {
      default: _withCtx(() => [_createTextVNode(" 返回上一页 ")]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  });
}